import { Component, ElementRef, inject, ViewChild } from '@angular/core';
import { LayoutService } from '@layout';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';

import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  standalone: true,
  imports: [BreadcrumbComponent, ButtonModule, InputTextModule],
})
export class TopbarComponent {
  @ViewChild('menubutton') menuButton!: ElementRef;

  public layoutService = inject(LayoutService);

  onMenuButtonClick() {
    this.layoutService.onMenuToggle();
  }

  onProfileButtonClick() {
    this.layoutService.showProfileSidebar();
  }

  onConfigButtonClick() {
    this.layoutService.showConfigSidebar();
  }
}
